import { useState, useEffect } from 'react';

import { useRuntime } from '@xing-com/crate-xinglet/internal';

interface TranslationsModule {
  messages: Record<string, string>;
}

/**
 * This hook is used to load translations for the given locale.
 * Xinglets are compiled one for each language
 * So we load the xinglet for the given locale.
 * We might have to update this if Crate decides to change something...
 *
 * @param locale - The language (e.g. 'de', 'en')
 * @returns { messages: [{key: 'ABC', value: 'copy text'}] }
 */
function useTranslations(locale: string): unknown {
  const runtime = useRuntime();
  const [module, setModule] = useState<TranslationsModule | null>(null);
  useEffect(() => {
    runtime
      .loadModule('@xing-com/crate-upsell-campaign-page', `lang-${locale}`)
      .then((mod) => {
        if (mod && typeof mod === 'object' && 'messages' in mod) {
          // oxlint-disable-next-line typescript/consistent-type-assertions
          setModule(mod as TranslationsModule);
        } else {
          console.error('Invalid module format');
        }
      })
      .catch((error) => console.error(error));
  }, [runtime, locale]);

  return module;
}

export default useTranslations;
